import React from 'react';
import { NavItem, NavMenu, Tab } from './SubTabs.elements';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import DocumentFileDropdown from 'components/DocumentFileDropdown';

export interface Tabs {
  onClick: () => void;
  label: string;
  isTabEnabled?: boolean;
  active: boolean;
  isVisible?: boolean;
  slug?: string;
}

interface Props {
  tabs: Tabs[];
  layer?: 'second' | 'third';
  hideOnMobile?: boolean;
  machineId?: string;
}
const MachineDocument = styled.div`
  width: 13rem;
`;
const SubTabs = ({ tabs, layer, hideOnMobile, machineId }: Props): JSX.Element => {
  if (!tabs || tabs.length === 0) console.error('sub tabs are not defined');

  const { t } = useTranslation(['mh']);

  return (
    <NavItem className="nav-item" layer={layer || 'second'} hideOnMobile={hideOnMobile}>
      <NavMenu className="nav-menu">
        {tabs?.map((subTab, index: number) => {
          const isEnabled = subTab?.isTabEnabled;
          return (
            <React.Fragment key={index}>
              <li className={`nav__menu-item${subTab.isVisible === false ? ' hidden' : ''}`}>
                <Tab
                  className="nav-menu__tab"
                  onClick={() => {
                    subTab?.isTabEnabled === false ? undefined : subTab.onClick?.();
                  }}
                  key={`${subTab.label}-${index}`}
                  $isSelected={subTab.active}
                  layer={layer || 'second'}
                  isTabEnabled={isEnabled}
                >
                  <span>{t(subTab?.label as string, { ns: ['mh', 'fpns'] })}</span>
                </Tab>
              </li>
            </React.Fragment>
          );
        })}
      </NavMenu>
      {machineId && (
        <MachineDocument>
          <DocumentFileDropdown
            machineId={machineId}
            categoryName="operation_and_maintenance_manual"
          />
        </MachineDocument>
      )}
    </NavItem>
  );
};

export default React.memo(SubTabs);
